import React from 'react';
import { useTheme } from 'providers/ThemeProvider';

import { TextArea } from 'components/Input/AutoResizeTextArea';
import Modal from 'components/Modal';
import utils from 'utils';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  setMessage: (message: string) => void;
  send: () => void;
}

const FeedbackModal = ({ isOpen, onClose, message = '', setMessage, send }: FeedbackModalProps) => {
  const { theme } = useTheme();
  const t = utils.intl.useTranslator();

  return (
    <Modal open={isOpen} onClose={onClose} closingOnOverlayClick={true} isDraggable={false}>
      <div>
        <Modal.Header title={utils.app.textTranslated('reportMessage', t, 'Report a message')} />
        <Modal.Content>
          <TextArea
            style={{ width: '390px', height: '120px', fontSize: theme.fontSizePalette.medium }}
            value={message}
            name={utils.app.textTranslated('feedback', t, 'Feedback')}
            placeholder={utils.app.textTranslated('writeSomeMoreDetails', t, 'Write some more details here')}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Modal.Content>
        <Modal.Footer
          confirmText={utils.app.textTranslated('send', t, 'Send')}
          confirmDisabled={!message}
          confirmAction={send}
          cancelAction={onClose}
        />
      </div>
    </Modal>
  );
};

export default FeedbackModal;
